import { createContext } from "react";
import type { StoreRegistry } from "./StoreRegistry";

export const StoreRegistryContext = createContext<StoreRegistry | null>(null);
